import { SURVEY_MAPPING } from './types';
import _ from "lodash";

export const setSurveyMappingDefault = () => {
    return {
        type: SURVEY_MAPPING.SET_SURVEY_MAPPING_DEFAULT,
    }
}

export const setSurveyMapping = (surveyMapping) => {
    return {
        type: SURVEY_MAPPING.SET_SURVEY_MAPPING,
        surveyMapping: surveyMapping
    }
}

export const setSurveyMappingValue = (draftType, orignalProduct, key, value, index) => {
    const surveyMapping = _.cloneDeep(orignalProduct);
    surveyMapping[draftType] = value;
    
    return {
        type: SURVEY_MAPPING.SET_SURVEY_MAPPING_VALUE,
        surveyMapping: surveyMapping
    }
}
